<template>

<div>
   <v-main id="app">
<v-slide-y-reverse-transition >
      <router-view v-show="show"/>
</v-slide-y-reverse-transition>
   </v-main>
  </div>
</template>

<script>
export default {
  created() {
    this.show = true;
  }
};
</script>



